export default "__VITE_ASSET__DsbJPKs___"